/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { User } from '@src/app/model/user';
import { TenantService } from '@src/app/shared/tenant.service';
import { FormTextComponent } from '@src/app/shared/form/form-text/form-text.component';
import { IsNarrowService } from '@src/app/shared/is-narrow.service';
import { required } from '@src/app/shared/validators';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CtlHolderComponent } from '@src/app/shared/form/ctl-holder/ctl-holder.component';
import { MatCardModule } from '@angular/material/card';
import { MessageService } from '@src/app/shared/message.service';

@Component({
    selector: 'app-new-agent',
    templateUrl: './new-agent.component.html',
    styleUrls: ['./new-agent.component.scss'],
    imports: [MatDialogContent, MatCardModule, CtlHolderComponent, MatButtonModule]
})
export class NewAgentComponent {
    private currentUserSvc = inject(CurrentUserService);
    private http = inject(HttpClient);
    private mdRef = inject<MatDialogRef<NewAgentComponent>>(MatDialogRef);


    isMobile = false;
    currentUser: User;

    msgSvc = inject(MessageService);

    newAgencyNameField = FormTextComponent.make('New Agency Name', 'agencyName', { validators: [required] });
    newAgencyNameCtl = this.newAgencyNameField.makeControl();

    newAgencyLegalField = FormTextComponent.make('Agency Legal Name', 'agencyLegalName', { validators: [required] });
    newAgencyLegalCtl = this.newAgencyLegalField.makeControl();

    slugField = FormTextComponent.make('Unique slug', 'slug', { validators: [required] });
    slugCtl = this.slugField.makeControl();    

    constructor() {
        const isNarrowSvc = inject(IsNarrowService);


        isNarrowSvc.detectVeryNarrow().pipe(takeUntilDestroyed()).subscribe(result => this.isMobile = result);
        this.currentUserSvc.getCurrentUser().pipe(takeUntilDestroyed()).subscribe(user => this.currentUser = user);
    }

    createAgency() {
        const name = this.newAgencyNameCtl.value;
        const legalName = this.newAgencyLegalCtl.value;
        const slug = this.slugCtl.value;

        const url = TenantService.bareAjaxPath + 'agency';
        this.http.post(url, { name, legalName, slug }).subscribe(success => {
            console.log(success);
            this.mdRef.close();
        }, failure => {
            this.msgSvc.showError(failure, 'Create Agency');
        })
    }
}
